export default __webpack_public_path__ + "static/media/Style 8.a3c1eaf2.svg";